import { SDrawerOrModal } from 'shj-components'
import styles from './index.module.less'
import { Tabs, Image, Tooltip, message, Button, Spin } from 'antd'
import ProductDeatail from '../ProductDeatail'
import { useEffect, useRef, useState } from 'react'
import { CopyOutlined, RightOutlined } from '@ant-design/icons'
import ChevronRight from '@/assets/ChevronRight.png'
import SpaceApply from '../SpaceApply'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import { cloneDeep } from 'lodash-es'
import { saveBudgetDtl, subtractSearch, updateQuoteBudgetDtl } from '@/services/order'
import _, { isArray, isEmpty } from 'lodash'
import tagsMap from '../../utils'

export default function ConfirmModal(props: any) {
  const {
    open,
    setOpen,
    record,
    spaceId,
    type,
    budgetId,
    generalId,
    btnInfo,
    modifyMode,
    reload,
    getGeneralList,
    mode,
    setSelectMaterialObj,
    reloadProductList,
    currentIndex,
    reConfirm,
  } = props
  const [combinationPrice, setCombinationPrice] = useState<any>(undefined) // 组合确定sku价格
  const [modifyCurrentSku, setModifyCurrentSku] = useState<any>({}) // 多规格确定sku信息
  const [materialDynaOptions, setMaterialDynaOptions] = useState<any>({}) // 报价属性信息
  const [groupList, setGroupList] = useState<any>([]) // 报价属性信息

  const [submitData, setSubmitData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [items, setItems] = useState<any>([])
  const [defaultActiveKey, setDefaultActiveKey] = useState<string>('1')
  const spaceRef = useRef<any>(null)
  const submitDataRef = useRef<any>({})
  const combinationPriceRef = useRef<any>({})
  const groupListRef = useRef<any>({})
  combinationPriceRef.current = combinationPrice
  groupListRef.current = groupList
  message.config({
    prefixCls: 'my-message',
  })
  submitDataRef.current = submitData
  const getAllSubSpace = async data => {
    let sameList: any = await subtractSearch({
      data: {
        searchKeyWord: data?.productSku?.id,
        quoteBudgetId: budgetId,
        prodType: null,
        type: 'SUB',
      },
    })
    if (sameList && sameList?.length) {
      sameList = sameList.map(item => {
        item.list = [
          {
            itemId: item?.budgetItemList[0]?.id, // 空间标识id,
            remark: '',
            budgetQtyValue: '',
            budgetQtyFormular: '',
          },
        ]
        return {
          ...item,
        }
      })
      data.subList = sameList
    }
  }
  const getFunc = val => {
    let funcRes: any = ''
    try {
      const func = new Function(`return ${val}`)
      funcRes = func()
    } catch (err) {
      funcRes = false
    }
    funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
    return funcRes
  }
  // useEffect(() => {
  //   console.log(record, 'record')
  //   let newData = cloneDeep(record || {})
  //   let items: any = []
  //   // 判断是选材是编辑规格信息还是列表修改已有的规格信息
  //   if (modifyMode === 'edit') {
  //     items = [
  //       {
  //         key: '1',
  //         label: '商品规格',
  //         children: (
  //           <ProductDeatail
  //             record={record}
  //             setCombinationPrice={setCombinationPrice}
  //             modifyCurrentSku={modifyCurrentSku}
  //             setModifyCurrentSku={setModifyCurrentSku}
  //             setMaterialDynaOptions={setMaterialDynaOptions}
  //             type={type}
  //             generalId={generalId}
  //             confirmInfo={confirmInfo}
  //             modifyMode={modifyMode}
  //             setLoading={setLoading}
  //           />
  //         ),
  //       },
  //     ]
  //   } else {
  //     if (type === 'SUB') {
  //       // 减项 需要塞入所有空间信息
  //       getAllSubSpace(newData)
  //     }
  //     // 添加默认空间信息
  //     if (type !== 'SUB' && newData && newData?.budgetItemList) {
  //       // 默认带入当前空间数据
  //       let defaultSpaceInfo = newData?.budgetItemList?.find(item => item.id === spaceId) || {}
  //       newData.list = []
  //       if (!isEmpty(defaultSpaceInfo)) {
  //         newData?.list.push({
  //           itemId: defaultSpaceInfo?.id, // 空间标识id,
  //           remark: '',
  //           budgetQtyValue: defaultSpaceInfo?.displayQtyFormular
  //             ? getFunc(defaultSpaceInfo?.displayQtyFormular)
  //             : '',
  //           budgetQtyFormular: defaultSpaceInfo?.displayQtyFormular,
  //         })
  //       }
  //     }
  //     // 有规格 有报价 有组合信息 都要显示商品规格
  //     if (
  //       (record?.productSpu?.skuSize > 0 && !isEmpty(record?.productSpu?.skuList[0]?.argMap)) ||
  //       record?.skuDynamicVoList?.length > 0 ||
  //       record?.productSpu?.combinationInfo?.length > 1
  //     ) {
  //       // 是否批量选材
  //       if (mode === 'multiple') {
  //         items = [
  //           {
  //             key: '1',
  //             label: '商品规格',
  //             children: (
  //               <ProductDeatail
  //                 record={record}
  //                 setCombinationPrice={setCombinationPrice}
  //                 modifyCurrentSku={modifyCurrentSku}
  //                 setModifyCurrentSku={setModifyCurrentSku}
  //                 setMaterialDynaOptions={setMaterialDynaOptions}
  //                 type={type}
  //                 generalId={generalId}
  //                 confirmInfo={confirmInfo}
  //                 setLoading={setLoading}
  //               />
  //             ),
  //           },
  //         ]
  //       } else {
  //         items = [
  //           {
  //             key: '1',
  //             label: '商品规格',
  //             children: (
  //               <ProductDeatail
  //                 record={record}
  //                 setCombinationPrice={setCombinationPrice}
  //                 modifyCurrentSku={modifyCurrentSku}
  //                 setModifyCurrentSku={setModifyCurrentSku}
  //                 setMaterialDynaOptions={setMaterialDynaOptions}
  //                 type={type}
  //                 generalId={generalId}
  //                 confirmInfo={confirmInfo}
  //                 setLoading={setLoading}
  //               />
  //             ),
  //           },
  //           {
  //             key: '2',
  //             label: '应用空间',
  //             children: (
  //               <SpaceApply
  //                 type={type}
  //                 ref={spaceRef}
  //                 submitData={newData}
  //                 spaceId={spaceId}
  //                 recordData={record}
  //               ></SpaceApply>
  //             ),
  //           },
  //         ]
  //       }
  //     } else {
  //       items = [
  //         {
  //           key: '2',
  //           label: '应用空间',
  //           children: (
  //             <SpaceApply
  //               type={type}
  //               ref={spaceRef}
  //               submitData={newData}
  //               spaceId={spaceId}
  //               recordData={record}
  //             ></SpaceApply>
  //           ),
  //         },
  //       ]
  //     }
  //   }
  //   setItems(items)
  //   setSubmitData({ ...newData })
  // }, [record])

  // 代码后优化 ↓↓↓↓↓
  function buildDefaultSpaceInfo(data, spaceId) {
    const defaultSpaceInfo = data.budgetItemList?.find(item => item.id === spaceId)
    if (defaultSpaceInfo) {
      data.list = [
        {
          itemId: defaultSpaceInfo.id,
          remark: '',
          budgetQtyValue: defaultSpaceInfo.displayQtyFormular
            ? getFunc(defaultSpaceInfo.displayQtyFormular)
            : '',
          budgetQtyFormular: defaultSpaceInfo.displayQtyFormular,
        },
      ]
    }
    return data
  }

  function shouldShowProductDetail(record) {
    const hasSku =
      record?.productSpu?.skuSize > 0 && !isEmpty(record?.productSpu?.skuList?.[0]?.argMap)
    const hasDynamicVo = record?.skuDynamicVoList?.length > 0
    const hasCombination = record?.productSpu?.combinationInfo?.length > 1
    return hasSku || hasDynamicVo || hasCombination
  }

  function createProductDetailItem(props) {
    return {
      key: '1',
      label: '商品规格',
      children: <ProductDeatail {...props} />,
    }
  }

  function createSpaceApplyItem({ type, spaceRef, newData, spaceId, record }) {
    return {
      key: '2',
      label: '应用空间',
      children: (
        <SpaceApply
          type={type}
          ref={spaceRef}
          submitData={newData}
          spaceId={spaceId}
          recordData={record}
        />
      ),
    }
  }

  function buildTabItems({
    record,
    newData,
    modifyMode,
    mode,
    type,
    generalId,
    confirmInfo,
    setCombinationPrice,
    modifyCurrentSku,
    setModifyCurrentSku,
    setMaterialDynaOptions,
    setLoading,
    spaceRef,
    spaceId,
  }) {
    if (modifyMode === 'edit') {
      return [
        createProductDetailItem({
          record,
          setCombinationPrice,
          modifyCurrentSku,
          setModifyCurrentSku,
          setMaterialDynaOptions,
          type,
          generalId,
          confirmInfo,
          modifyMode,
          setLoading,
        }),
      ]
    }

    const showProduct = shouldShowProductDetail(record)
    const productItem = createProductDetailItem({
      record,
      setCombinationPrice,
      modifyCurrentSku,
      setModifyCurrentSku,
      setMaterialDynaOptions,
      type,
      generalId,
      confirmInfo,
      setLoading,
    })

    const spaceItem = createSpaceApplyItem({ type, spaceRef, newData, spaceId, record })

    if (showProduct) {
      return mode === 'multiple' ? [productItem] : [productItem, spaceItem]
    } else {
      return [spaceItem]
    }
  }

  useEffect(() => {
    console.log(record, 'record')
    let newData = cloneDeep(record || {})
    if (!newData) return
    // 🧩 Step 1: 处理空间信息
    if (modifyMode !== 'edit') {
      if (type === 'SUB') {
        getAllSubSpace(newData)
      } else if (newData?.budgetItemList) {
        newData = buildDefaultSpaceInfo(newData, spaceId)
      }
    }
    // 🧩 Step 2: 根据条件决定要展示哪些 tab
    const items = buildTabItems({
      record,
      newData,
      modifyMode,
      mode,
      type,
      generalId,
      confirmInfo,
      setCombinationPrice,
      modifyCurrentSku,
      setModifyCurrentSku,
      setMaterialDynaOptions,
      setLoading,
      spaceRef,
      spaceId,
    })

    setItems(items)
    setSubmitData({ ...newData })
  }, [record])

  useEffect(() => {
    console.log(combinationPrice, 'combinationPrice')
    combinationPriceRef.current = combinationPrice
  }, [combinationPrice])
  useEffect(() => {
    console.log(modifyCurrentSku, 'modifyCurrentSku多规格确定sku后的信息')
    // 选材之后确定SKU码
    if (!isEmpty(modifyCurrentSku)) {
      submitData.dynaOptions = modifyCurrentSku.argMap
      submitData.productSkuName = modifyCurrentSku.skuName
      submitData.productSkuSalePrice = modifyCurrentSku.priceInfo?.customerPrice
      submitData.productSkuId = modifyCurrentSku.id
      submitData.longDesc = modifyCurrentSku?.longDesc
      submitData.productSpuPrimaryImage =
        modifyCurrentSku?.mainPicUrl || submitData?.productSpuPrimaryImage
      setSubmitData({ ...submitData })
    }
  }, [modifyCurrentSku])
  const handleLongDesc = data => {
    // 子产品有且只有一个为来源物料 工艺说明为该子产品的sku的工艺说明
    let materialList = data?.filter(
      (item: any) => item?.product?.sourceType === 'MATERIAL' && item?.checked
    )
    if (materialList.length === 1) {
      let skuInfo = materialList[0]?.skuList?.find(
        (el: any) => el.id === materialList[0]?.selectSkuId
      )
      return skuInfo?.longDesc
    } else {
      return ''
    }
  }
  const confirmInfo = (combinationInfoDetail: any, combinationPrice: number) => {
    console.log(combinationInfoDetail, '组合数据')
    setGroupList(combinationInfoDetail)
    if (combinationInfoDetail && combinationInfoDetail?.length) {
      // 确认组合信息
      const hasSkuList = combinationInfoDetail.filter(item => item.selectSkuId)
      const hasCheckedList = combinationInfoDetail.filter(item => item.checked)
      console.log(hasSkuList, 'hasSkuList')
      console.log(hasCheckedList, 'hasCheckedList')
      // let noSkuProdInfo: any = {}
      // if (hasSkuList?.length !== hasCheckedList?.length) {
      //   noSkuProdInfo = hasCheckedList?.filter(item => !item.selectSkuId)?.[0]
      //   return
      // }

      let newData = cloneDeep(submitDataRef.current || {})
      let longDesc = ''
      longDesc = handleLongDesc(combinationInfoDetail)
      newData.packDtlList = combinationInfoDetail
      newData.productSkuSalePrice =
        combinationPrice || combinationPrice === 0
          ? combinationPrice
          : submitData.productSkuSalePrice
      newData.longDesc = longDesc
      console.log(newData, 'newData3333333333')
      setLoading(false)
      setSubmitData({ ...submitDataRef.current, ...newData })
    }
  }

  useEffect(() => {
    if (materialDynaOptions && materialDynaOptions?.length) {
      console.log(materialDynaOptions, 'materialDynaOptions')
      if (materialDynaOptions?.every(item => item?.optionId)) {
        // 所有报价属性都选中才提交
        submitData.materialDynaOptions = materialDynaOptions
        setSubmitData({ ...submitData })
      }
    }
  }, [materialDynaOptions])
  const onChange = (key: string) => {
    console.log(key)
    setDefaultActiveKey(key)
  }
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }
  const clickToDetail = record => {
    window.open(
      `/order/materialSelectionLibrary/materialDetail/${record?.productSpu?.id || record?.prdId}`,
      '_blank'
    )
  }
  const priceHandle = price => {
    if (price) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')

      if (Number(dec)) {
        return (
          <>
            <span>{int}</span>
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return <span>{int}</span>
      }
    } else if (price == 0) {
      return <span>{0}</span>
    } else {
      return '--'
    }
  }
  useEffect(() => {
    console.log(submitData, 'submitData')
  }, [submitData])
  const validateFunc = () => {
    console.log(submitDataRef.current, 'submitDataRef.current22222222')
    let flag = true
    if (submitDataRef.current?.packDtlList?.length) {
      for (let index = 0; index < submitDataRef.current?.packDtlList.length; index++) {
        const element = submitDataRef.current?.packDtlList[index]
        if (element?.required && !element?.selectSkuId || (!element?.required&&element?.checked&&!element?.selectSkuId)) {
          message.error(
            `产品SPU：${element?.prodName}-${element?.id}未对应上SKU，请检查，可能原因：①没有适用该门店的SKU；②未选择商品规格`
          )
          flag = false
          break
        }
      }
    }
    return flag
  }
  const handleSubmit = () => {
    if (!validateFunc()) return

    if (modifyMode === 'edit') {
      setLoading(true)
      let editObj = {
        quoteBudgetId: budgetId,
        quoteBudgetDtlId: submitData?.id,
        productSkuId: submitData?.productSkuId || submitData?.prdSkuId,
        dynaOptions: submitData?.dynaOptions || null,
        materialDynaOptions: submitData?.materialDynaOptions || null,
        packDtlList: submitData?.packDtlList
          ? submitData?.packDtlList.filter(el => el.selectSkuId && el.checked)
          : null,
      }
      updateQuoteBudgetDtl(editObj)
        .then(res => {
          message.success('修改成功')
          setOpen(false)
          reload?.()
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      // 区分是否批量选材
      if (mode === 'multiple') {
        // 判断初次加入还是回显
        if (reConfirm && (currentIndex || currentIndex === 0)) {
          // 回显
          reConfirm?.(submitDataRef.current)
          setOpen(false)
        } else {
          setSelectMaterialObj(submitDataRef.current)
          message.success('已加入批量设置空间')
          setOpen(false)
        }
      } else {
        // 提前判断是否有空间明细
        if (!spaceRef.current?.spaceData) {
          message.error('请先填写应用空间')
          setDefaultActiveKey('2')
          return
        }
        const submitList = postData(submitDataRef.current)
        setLoading(true)
        // 以数组形式提交
        saveBudgetDtl({
          data: submitList.filter(el => el.checked),
        })
          .then((res: any) => {
            console.log(res)
            if (res && res.length) {
              message.error('提交失败')
            } else {
              message.success('添加选材成功')
              getGeneralList?.()
              reloadProductList?.()
              setOpen(false)
            }
          })
          .catch(err => {
            if (err?.message?.includes('应用空间') || err?.message?.includes('预算量')) {
              setDefaultActiveKey('2')
            }
          })
          .finally(() => {
            setLoading(false)
          })
      }
    }
  }
  const postData = item => {
    item.quoteBudgetId = budgetId
    item.type = type // 为通项传值
    item.list = spaceRef.current?.spaceData
    // item.addType = currentSearchParams.sourceType || null
    // 空间明细字段处理
    if (item?.list && item?.list.length) {
      item.spaceChecked = item?.list.map(el => el.itemId)
    }

    if (type === 'SUB') {
      item.list.forEach((el: any) => {
        el.reduceSourceBudgetDtlId = item.referenceId
      })
    }
    // }
    if (
      (type === 'ADD' && !item.budgetItemList?.length) ||
      (type === 'SUB' && !item.budgetItemList?.length) ||
      (type === 'PROJECT' && !item.budgetItemList?.length)
    ) {
      // 无空间信息 但有一条预算量计算式
      const array: any = []
      array.push({
        itemId: spaceId,
        remark: item.remark || '',
        budgetQtyValue: item.calculateFunc,
        budgetQtyFormular: item.calculate || '',
      })
      item.list = array
    }
    item.dynaOptions = item.dynaOptions ? item.dynaOptions : item.productSku?.argMap
    // 处理产品明细
    if (item.packDtlList?.length) {
      item.packDtlList = item.packDtlList.filter(el => el.selectSkuId && el.checked)
    }
    item.refItemId = spaceId // 通项 项目传空间ID 其它传按钮id

    // 每种类型特殊字段处理
    switch (item.type) {
      case 'ACTIVITY':
        item.activityId = item.activity?.id
        item.activityProductId = item.activityProduct?.id
        item.refItemId = btnInfo?.id
        delete item.generalId
        break
      case 'UP_DOWN':
        // 升降级 需要传参通项Id
        item.refItemId = btnInfo?.id
        // item.generalId = currentSearchParams.generalId // 通项id
        break
      case 'SUB':
        item.reduceSourceBudgetDtlId = item.referenceId
        item.refItemId = btnInfo?.id
        item.generalId = item.generalItemManageId
        break
      case 'ADD':
        item.refItemId = btnInfo?.id
        item.generalId = item.generalItemManageId
        break
      default:
        break
    }
    return [item]
  }
  const handlePriceBox = () => {
    // 产品自身价格 多规格修改后价格  组合价格
    let price =
      modifyCurrentSku?.priceInfo?.customerPrice ?? combinationPrice ?? record?.productSkuSalePrice
    if (record?.materialDynaOptions?.length || record?.skuDynamicVoList?.length) {
      price = record?.saleCustPrice ?? record?.productSkuSalePrice
    }

    return priceHandle(price)
  }
  useEffect(() => {
    groupListRef.current = groupList
  }, [groupList])
  // 国补
  const showNationalTagRender = (item?: any) => {
    let newCombinationInfoList = groupListRef.current
    // 造数据
    // 判断是否除了施工项都是国补 是则显示 国补标签
    let proList = newCombinationInfoList
      ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
      ?.filter(item => item.required || (!item.required && item.checked))
    let allNational = false
    if (proList?.length) {
      allNational = proList?.every((item: any) => {
        if (item.selectSkuId) {
          return item?.skuList?.find((sku: any) => sku.id === item.selectSkuId)?.showTags
        }
        return false
      })
    }
    if (allNational) {
      return (
        <div
          className={'normal_tag_style'}
          style={{
            color: tagsMap.NATIONAL_UPPLEMENT?.color,
            backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
            marginRight: '8px',
            lineHeight: '22px',
            height: '22px',
          }}
        >
          <Tooltip title={'国补'}>国补</Tooltip>
        </div>
      )
    } else {
      let showTags = submitData?.productSpu?.skuList?.find(
        (sku: any) => sku.id === submitData.productSkuId
      )?.showTags
      if (showTags && isArray(showTags)) {
        return showTags?.map((tag: any) => {
          return (
            <div
              className={'normal_tag_style'}
              style={{
                color: tagsMap[tag.tagCode]?.color,
                backgroundColor: tagsMap[tag.tagCode]?.bgColor,
                marginRight: '8px',
                lineHeight: '22px',
                height: '22px',
              }}
            >
              <Tooltip title={tag.tagName}>{tag.tagName}</Tooltip>
            </div>
          )
        })
      } else {
        return <></>
      }
    }
  }
  return (
    <SDrawerOrModal
      open={open}
      onCancel={() => {
        setOpen(false)
      }}
      width={1000}
      mode="modal"
      title={
        !(
          (record?.productSpu?.skuSize > 0 && !isEmpty(record?.productSpu?.skuList[0]?.argMap)) ||
          record?.skuDynamicVoList?.length > 0 ||
          record?.productSpu?.combinationInfo?.length > 1 ||
          modifyMode === 'edit'
        )
          ? '应用空间'
          : mode === 'multiple' || modifyMode === 'edit'
            ? '商品规格'
            : '商品规格和应用空间'
      }
      antdProps={{
        footer: (
          <div className={styles.footer}>
            <div className={styles.priceBox}>
              <span className={styles.priceBoxSmall}>￥</span>
              {handlePriceBox() || 0}
              {record?.productSpuUnitName && (
                <span className={styles.priceBoxSmall}>/{record?.productSpuUnitName}</span>
              )}
            </div>
            <div className={styles.btnBox}>
              <Button
                onClick={() => {
                  setOpen(false)
                }}
                loading={loading}
              >
                取消
              </Button>
              <Button
                loading={loading}
                type="primary"
                onClick={handleSubmit}
                style={{ marginLeft: '8px', height: '38px' }}
              >
                {modifyMode === 'edit' ? '确定' : '确认选材'}
              </Button>
            </div>
          </div>
        ),
        centered: true,
      }}
    >
      <div className={styles.productListContainer_Modal} id="productListContainer_Modal">
        <Spin spinning={loading}>
          <div className={styles.mainBox}>
            <div className={styles.imgBox}>
              <Image.PreviewGroup
                items={record?.productSpu?.imageUrls || record?.imageUrls || undefined}
              >
                <Image
                  src={record?.productSpuPrimaryImage || record?.mainPic}
                  className={styles.img}
                />
              </Image.PreviewGroup>
            </div>
            <div className={styles.infoBox}>
              <div className={styles.titleBox}>
                <div className={styles.title}>
                  {showNationalTagRender(record)}
                  <Tooltip title={record?.productSpuName || record?.name} placement="topLeft">
                    {record?.productSpuName || record?.name}
                  </Tooltip>
                </div>
                <Tooltip
                  title={record?.productSpu?.longDesc || record?.longDesc}
                  placement="topLeft"
                  arrow={false}
                >
                  {(record?.productSpu?.longDesc || record?.longDesc) && (
                    <div className={styles.longDesc}>
                      工艺说明： {record?.longDesc || record?.productSpu?.longDesc}
                    </div>
                  )}
                </Tooltip>
                <p className={styles.spuBox}>
                  <span>SPU：</span>
                  {record?.productSpu?.id || record?.prdId}
                  <CopyOutlined
                    style={{ marginLeft: '8px' }}
                    className="copyIcon"
                    onClick={() => {
                      clickToCopy(record?.productSpu?.id || record?.prdId)
                    }}
                  />
                </p>
                <div className={styles.checkoutBtn} onClick={() => clickToDetail(record)}>
                  <p>查看商品详情</p>
                  <img src={ChevronRight} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '12px' }}>
            <Tabs
              renderTabBar={(props, DefaultTabBar) => (
                <>{items?.length > 1 ? <DefaultTabBar {...props} /> : <div></div>}</>
              )}
              defaultActiveKey={'1'}
              activeKey={items?.length > 1 ? defaultActiveKey : undefined}
              items={items}
              onChange={onChange}
            />
          </div>
        </Spin>
      </div>
    </SDrawerOrModal>
  )
}
